import { createContext, useState } from 'react';
import { PropTypes } from 'prop-types';

export const BlogCarouselContext = createContext();

const BlogCarouselContextProvider = ({ children }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [totalSlide, setTotalSlide] = useState(3);

  const next = () => {
    setActiveSlide((prev) => {
      if (prev === totalSlide - 1) {
        return 0;
      } else {
        return prev + 1;
      }
    });
  };

  const prev = () => {
    setActiveSlide((prev) => {
      if (prev === 0) {
        return totalSlide - 1;
      } else {
        return prev - 1;
      }
    });
  };

  return (
    <BlogCarouselContext.Provider
      value={{
        activeSlide,
        next,
        prev,
        setActiveSlide,
        setTotalSlide,
        totalSlide,
      }}
    >
      {children}
    </BlogCarouselContext.Provider>
  );
};

BlogCarouselContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BlogCarouselContextProvider;
